export const useHistory = () => ({
  push: (url) =>
    typeof window.history?.pushState === "function" &&
    window.history.pushState({}, "", new URL(url)),
});
